module.exports = __webpack_public_path__ + "static/berger-mobile-3da4a2aa096f67e7a57290f609293a09.jpg";